import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dialog: {
    zIndex: `1300 !important`,
  },
  appBar: {
    position: 'relative',
  },
  toolbar: {
    height: 70,
  },
  title: {
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    fontWeight: 'bold',
  },
  container: {
    position: 'relative',
    padding: theme.spacing(4),
    width: '80%',
    maxWidth: 600,
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: 0,
    },
  },

  list: {
    '& > li': {
      backgroundColor: theme.palette.action.disabled,
      marginBottom: 3,
    },
  },
  selectAll: {
    borderBottom: `1px solid ${theme.colors.darkGrey}`,
  },
  listItem: {
    marginBottom: 3,
  },
  assigneeText: {
    color: 'black',
  },
  buttonWrap: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(1),
    },
  },
  buttonContainer: {
    paddingTop: theme.spacing(2),
  },
  button: {
    color: theme.colors.white,
    marginRight: theme.spacing(1),
  },
  secondaryAction: {
    height: '100%',
    borderLeft: 'solid lightgrey 1px',
    right: 0,
  },
  secondaryButton: {
    height: '100%',
    width: '100%',
    alignText: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  dontNotify: {
    backgroundColor: theme.palette.action.disabled,
    '&:hover': {
      backgroundColor: theme.colors.darkGrey,
    },
  },
  share: {
    backgroundColor: theme.colors.blue,
    '&:hover': {
      backgroundColor: theme.colors.darkBlue,
    },
  },
  notify: {
    backgroundColor: theme.colors.darkBlue,
    '&:hover': {
      backgroundColor: theme.colors.darkGrey,
    },
  },
  childList: {
    marginLeft: theme.spacing(2),
  },
  imageIcon: {
    position: 'absolute',
    bottom: 2,
    right: 2,
    color: theme.colors.white,
  },
  whiteIcon: {
    color: theme.colors.white,
  },
  checkbox: {
    minWidth: 'inherit',
  },
}));

export default useStyles;
